import { IItem } from 'app/components/search-bar';

type Facility = {
  id?: string;
  name?: string;
  facilityAlias?: string;
  companyAlias?: string;
  isActive?: boolean | null;
};

export function convertToSearchableFacility<T extends Facility>({
  id,
  name,
  companyAlias,
  facilityAlias,
  isActive,
}: T): IItem | undefined {
  if (!name || !facilityAlias || !companyAlias) return;
  if (!isActive) return;
  return {
    key: id,
    description: name,
    label: `${companyAlias}_${facilityAlias}`,
    searchString: `${name} ${companyAlias} ${facilityAlias} ${companyAlias}_${facilityAlias}`,
  };
}
